import { createContext, useCallback, useContext, useEffect, useState } from 'react';

import { CancelToken } from 'axios';

import { useConfigContext } from 'redesign/components/common/contexts/ConfigManager';
import localStorage from 'redesign/helpers/localStorage';
import AuthClient from 'services/api/auth_client';

export type CarrierInfo = Array<{ name: string; code: string; is_selected: boolean }>;

const emptyCarrierInfo: CarrierInfo = [];

interface CarrierContext {
    carrierInfo: CarrierInfo;
    fetchCarriers: () => void;
    selectCarrier: any;
}

const carrierContext = createContext<CarrierContext>({
    carrierInfo: emptyCarrierInfo,
    fetchCarriers: () => undefined,
    selectCarrier: () => undefined,
});

export const useCarrierContext = () => useContext(carrierContext);

const CarrierManager = ({ children }: { children: JSX.Element }) => {
    const {
        config: { divisions: divisionsConfig, filtersKey },
        fetchConfig,
    } = useConfigContext();

    const [carrierInfo, setCarrierInfo] = useState(emptyCarrierInfo);
    const client = new AuthClient();
    const fetchCarriers = async (cancelToken?: CancelToken) => {
        const response = await client.getCarriers(cancelToken);
        setCarrierInfo(response);
        return response;
    };

    useEffect(() => {
        if (divisionsConfig?.enabled) {
            fetchCarriers();
        }
    }, [divisionsConfig?.enabled]);

    const selectCarrier = useCallback(
        async (code: string) => {
            /* TODO Ideally, this should not be done manually, but on each config reload,
        where carrier has changed, remove filters from localstrage */
            localStorage.remove(filtersKey);
            await client.selectCarrier(code);
            setCarrierInfo(ex =>
                ex.map(c =>
                    c.code === code ? { ...c, is_selected: true } : { ...c, is_selected: false }
                )
            );
            fetchConfig();
        },
        [filtersKey]
    );

    return (
        <carrierContext.Provider
            value={{
                carrierInfo,
                fetchCarriers,
                selectCarrier,
            }}
        >
            {children}
        </carrierContext.Provider>
    );
};

export default CarrierManager;
